import toast from "react-hot-toast";
import { postEnrollForFreeCourse } from "../components/Tabs/Overview/store/services";
import { store } from "@root/store";
import { showCongratulationsBottomSheetAction, showEnrollForFreeCourseBottomSheetAction } from "../components/BottomSheets/store/actions";

export const enrollOnFreeCourse = async () => {
    try {
      const orderPayload = createPayload()
      const response = await postEnrollForFreeCourse(orderPayload)
      if(response?.data?.status === "success"){
        store.dispatch(showEnrollForFreeCourseBottomSheetAction(false));
        toast.success("Success")
        store.dispatch(showCongratulationsBottomSheetAction({
          show: true,
        }))
      }
    } catch (error) {
      console.log(error.message)
      toast.error("Something went wrong, Please try again")
    }
}

const createPayload = () => {
  let storeState = store.getState();

  let metaData = storeState?.overviewReducer?.overViewDetails?.course?.metaData;

  const dynamicBundleAddress =
    storeState?.overviewReducer?.dynamicCoursePrice?.priceBottom
      ?.isPhyicalShipmentCourse;
  const stateSelected = storeState?.overviewReducer?.stateSelected;
    
  let isPhysicalDeliveryEnabled = metaData?.isPhysicalDeliveryEnabled;

  const activeAddress = storeState?.physicalShipmentReducer?.activeAddress;
  

  let isCouponApplied = 0;
  let courseId = metaData?.id;

  let appliedCoupon =
    storeState?.overviewReducer?.graphCourseData?.appliedCoupon;

  if (appliedCoupon?.redeemId) {
    isCouponApplied = 1;
  }

  let paymentPayload = {
    isCouponApplied: 0,
    currentAmount: 0,
    couponCode: null,
    redemptionId: null,
    state: stateSelected,
    deliveryAddressId:
      isPhysicalDeliveryEnabled || dynamicBundleAddress
        ? activeAddress?.id
        : 0,
    ocvmId: storeState?.overviewReducer?.promotedValidity?.id
      ? storeState?.overviewReducer?.promotedValidity?.id
      : null,
    courseId: courseId,
    apiVersion: 51,
    returnUrl: window?.location?.origin + window?.location?.pathname
  };
  return paymentPayload
}